import { createStore } from 'owa-satcheljs';

export type MyOutlookTab = 'today' | 'unwrapped' | 'mirror' | 'automations' | 'scanProgress';

// The folder-pane MyOutlook section only surfaces once onboarding is complete:
// 'firstComplete' shows the onramp card (reveal unseen), 'steady' shows the
// normal rows (reveal seen). Pre-completion there is no in-app UI, so there are
// no 'uninitiated' / 'scanning' states — the section simply renders nothing.
export type MyOutlookEntryState = 'firstComplete' | 'steady';

export interface MyOutlookViewState {
    isFullPageShowing: boolean;
    initialTab: MyOutlookTab;
    isSectionHidden: boolean;
    // Dev-only override for the folder-pane entry state. Never persisted —
    // resets to null on refresh. See setEmulatedFolderEntryStateMutator.
    emulatedEntryState: MyOutlookEntryState | null;
    // Whether the schedule timeline is visible on the full page.
    isScheduleVisible: boolean;
    // Actionable-item ids to highlight, driven by hovering / focusing a
    // briefing narrative sentence (matched against the sentence's citations).
    // Purely transient view state — never persisted.
    highlightedActionableItemIds: string[];
}

const getMyOutlookViewState: () => MyOutlookViewState = createStore<MyOutlookViewState>(
    'MyOutlookViewState',
    {
        isFullPageShowing: false,
        initialTab: 'today' as MyOutlookTab,
        isSectionHidden: false,
        emulatedEntryState: null,
        isScheduleVisible: true,
        highlightedActionableItemIds: [],
    }
);

export default getMyOutlookViewState;
